// extracted by mini-css-extract-plugin
export default {"menu":"MenuItem_menu__4639d","active":"MenuItem_active__IxGlK"};